import { AppElement, html } from '../AppElement.js';

export default class PageBeastSetup extends AppElement {
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('message', infinito.vao.messaging.handler);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('message', infinito.vao.messaging.handler);
  }

  updated(...args) {
    super.updated(...args);
    window.addEventListener('message', infinito.vao.messaging.handler);
  }

  render() {
    const authToken = localStorage.getItem('token');
    const hotel = window.infinito.vao.controller.storageHelper.getSelectedHotel();
    return html`
      <div style="height: 100%">
        <iframe src="https://web.infinito.solutions/app/beast/cluster-setup?embed=true&authToken=${authToken}&HotelID=${hotel.id}"
                frameBorder="0" style="width: 100%; height: 100%;"></iframe>
      </div>
    `;
  }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.PageBeastSetup = PageBeastSetup;
customElements.define('vao-page-beast-setup', PageBeastSetup);
